import React from 'react';
var ReactEditorViewContext = /*#__PURE__*/React.createContext({});
export default ReactEditorViewContext;